












































































import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import { types } from '../../api_types';
import common_Typeahead from '../common/Typeahead.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
library.add(faTimes);

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-common-typeahead': common_Typeahead,
  },
})
export default class ProblemSearchBar extends Vue {
  @Prop() tags!: string[];
  @Prop() keyword!: string;
  @Prop() language!: string;
  @Prop() languages!: string[];
  @Prop() onlyQualitySeal!: boolean;
  @Prop() searchResultProblems!: types.ListItem[];

  T = T;

  currentKeyword: types.ListItem = { key: this.keyword, value: this.keyword };
  currentLanguage = this.language;
  currentOnlyQualitySeal = this.onlyQualitySeal;

  getLanguageText(language: string): string {
    if (language === 'all') return T.wordsAll;
    if (language === 'en') return T.wordsEnglish;
    if (language === 'es') return T.wordsSpanish;
    return T.wordsPortuguese;
  }

  get currentKeywordValue(): null | string {
    return this.currentKeyword?.value ?? null;
  }
}
